import React from "react";
import "./scss/main.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./components/pages/Dashboard";
import Connect from "./components/pages/Connect";
import routes from "./constants/routes";
import Sidebar from "./components/layout/Sidebar";
import Header from "./components/layout/Header";
import History from "./components/pages/History";
import Wallet from "./components/pages/Wallet";
import CreateToken from "./components/pages/CreateToken";
import CreateToken2 from "./components/pages/CreateToken2";
import CreateToken3 from "./components/pages/CreateToken3";
import CreateToken4 from "./components/pages/CreateToken4";
import { useSelector } from "react-redux";
import Maintenance from "./components/pages/Maintenance";
import PopupMessage from "./components/global/PopupMessage";
import SendToken from "./components/pages/SendToken";
import { createClient, Provider } from "urql";

if (process.env.NODE_ENV === "production") {
}
const client = createClient({
  url:
    process.env.REACT_APP_SQUID_ENDPOINT ||
    "https://explorer-service.rivius.network/graphql",
});
const App = () => {
  const { theme } = useSelector((state) => state?.theme);

  return (
    <>
      {process.env.REACT_APP_MAINTENANCE == "true" ? (
        <>
          <Maintenance />
        </>
      ) : (
        <Provider value={client}>
          <PopupMessage />
          <BrowserRouter>
            <div className={`g-app ${theme}`} data-theme={theme}>
              <Sidebar />
              <div className="g-rightSide">
                <Header />
                <div className="g-content" id="g-content">
                  <Routes>
                    <Route path={routes.wallet} element={<Wallet />} />
                    <Route path={routes.history} element={<History />} />
                    <Route path={routes.sendToken} element={<SendToken />} />
                    <Route
                      path={routes.createToken}
                      element={<CreateToken />}
                    />
                    <Route
                      path={routes.createToken2}
                      element={<CreateToken2 />}
                    />
                    <Route
                      path={routes.createToken3}
                      element={<CreateToken3 />}
                    />
                    <Route
                      path={routes.createToken4}
                      element={<CreateToken4 />}
                    />
                    <Route path={routes.connect} element={<Connect />} />
                    <Route path={routes.dashboard} element={<Dashboard />} />
                    <Route path="*" element={<Dashboard />} />
                  </Routes>
                </div>
              </div>
            </div>
          </BrowserRouter>
        </Provider>
      )}
    </>
  );
};

export default App;
